var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./TableBody.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler?id=data-v-31609f21!../../../vue-loader/lib/selector?type=template&index=0!./TableBody.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue2-datatable-component/src/Table/TableBody.vue
// module id = 1215
// module chunks = 2